import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirebaseConfig } from "../userEndApi/AuthApi/FirebaseApi";

let firebaseApp = null;
let firebaseAuth = null;

/**
 * Initialize Firebase dynamically with configuration from the backend
 */
const initializeFirebase = async () => {
    try {
        if (firebaseApp) return { app: firebaseApp, auth: firebaseAuth };

        const configResponse = await getFirebaseConfig();
        
        if (!configResponse.success) {
            throw new Error(configResponse.message || "Failed to fetch Firebase config");
        }

        const firebaseConfig = configResponse.data;
        
        // Initialize Firebase
        firebaseApp = initializeApp(firebaseConfig);
        firebaseAuth = getAuth(firebaseApp);
        
        return { app: firebaseApp, auth: firebaseAuth };
    } catch (error) {
        console.error("Firebase initialization failed:", error);
        throw error;
    }
};

/**
 * Get initialized Firebase Auth instance
 */
export const getFirebaseAuth = async () => {
    if (!firebaseAuth) {
        const { auth } = await initializeFirebase();
        return auth;
    }
    return firebaseAuth;
};

export default initializeFirebase;
